// extracted by mini-css-extract-plugin
export var logo = "_by-2";
export var logoWrapper = "_by-1";
export var strip = "_by-0";